import { IExperiment } from '../../types/experiments';

export function getExperiment(experiments: IExperiment[], experimentName: string): IExperiment | undefined {
  return experiments.find(o => o.experimentName === experimentName);
}
